<template>
    <div id="create-forms">
        <div class="container" v-if="isCreateFormVisible">
            <h2>{{ $t("form.createForm") }}</h2>
            <h4>{{ $t("form.createOrTransferaForm") }}</h4>
            <div class="card-wrapper" @click="$feature.beforeCreateForm(formBuilderOpen)">
                <div class="card">
                    <div class="card-content">
                        <div class="card-icon">+</div>
                        <div class="card-title">{{ $t("form.startFromScratch") }}</div>
                        <div class="card-description">{{ $t("form.startWithaBlankForm") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <FormBuilder v-if="formBuilder" :formId="formId" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FormBuilder from "./FormBuilder";

export default {
    name: "CreateForms",
    components: {
        FormBuilder,
    },
    props: {
        formId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            formBuilder: false,
            isCreateFormVisible: !this.formId,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            createForm: "forms/createForm",
        }),
        async formBuilderOpen() {
            try {
                const siteId = this.site._id;
                const title = "Yeni Form Başlığı";
                const fields = [
                    {
                        type: "title",
                        label: "Başlık",
                        title: {
                            titleText: "Başlık",
                            subTitle: "Form başlığınızı girin",
                            titleSize: "large",
                            titleAlign: "left",
                        },
                    },
                ];

                const form = await this.createForm({ siteId, title, fields });
                console.log("Form oluşturuldu:", form);
                const formId = form._id;

                this.formId = formId;
                this.formBuilder = true;
                this.isCreateFormVisible = false;
            } catch (error) {
                console.error("Form oluşturulamadı:", error);
            }
        },
    },
    watch: {
        formId: {
            immediate: true,
            handler(newFormId) {
                if (newFormId) {
                    this.formBuilder = true;
                    this.isCreateFormVisible = false;
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
#create-forms {
    min-height: 100vh;
    font-family: "Roboto", sans-serif;

    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 3rem 2rem;
        background: white;
        border-radius: 16px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
        width: 90%;
        max-width: 800px;
        margin: 2rem auto;
        position: relative;
        border: 1px solid #eef0f5;

        h2 {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 1rem;
            color: #2c3345;
        }

        h4 {
            font-size: 1.25rem;
            font-weight: 400;
            color: #6b7280;
            margin-bottom: 3rem;
        }

        .card-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
        }

        .card {
            position: relative;
            width: 260px;
            height: 260px;
            background: #f8f9fc;
            border-radius: 16px;
            cursor: pointer;
            transition: all 0.2s ease;
            border: 2px dashed #e5e7eb;

            &:hover {
                transform: translateY(-4px);
                border-color: #2c3345;
                background: white;

                .card-content {
                    .card-icon {
                        background: #2c3345;
                        color: white;
                        transform: rotate(90deg) scale(1.1);
                    }

                    .card-title {
                        color: #2c3345;
                    }

                    .card-description {
                        color: #4b5563;
                    }
                }
            }

            .card-content {
                position: relative;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 2rem;
                transition: transform 0.2s ease;

                .card-icon {
                    width: 64px;
                    height: 64px;
                    background: white;
                    border: 2px solid #e5e7eb;
                    border-radius: 12px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 2rem;
                    color: #2c3345;
                    margin-bottom: 1.5rem;
                    transition: all 0.2s ease;
                }

                .card-title {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #374151;
                    margin: 1rem 0;
                }

                .card-description {
                    font-size: 1rem;
                    color: #6b7280;
                    text-align: center;
                    line-height: 1.5;
                }
            }
        }
    }
}
</style>
